/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Will_Draft_Contextaware_ReInputs */

const en_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI will draft context-aware replies for you`)
};

const es_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA redactará respuestas conscientes del contexto por ti`)
};

const fr_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA rédigera pour vous des réponses tenant compte du contexte`)
};

const de_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI entwirft kontextbezogene Antworten für dich`)
};

const ja_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIがコンテキストを認識した返信を下書きします`)
};

const zh_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 将为您起草具备上下文感知的回复`)
};

const ar_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيقوم الذكاء الاصطناعي بصياغة ردود تراعي السياق نيابة عنك`)
};

const id_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI akan membuat draf balasan yang peka konteks untuk Anda`)
};

const it_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA redigerà risposte basate sul contesto per te`)
};

const ru_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ составит ответы с учетом контекста для вас`)
};

const pt_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA fará rascunhos de respostas cientes do contexto para você`)
};

const ko_ai_will_draft_contextaware_re = /** @type {(inputs: Ai_Will_Draft_Contextaware_ReInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 상황에 맞는 답변 초안을 작성해 줍니다`)
};

/**
* | output |
* | --- |
* | "AI will draft context-aware replies for you" |
*
* @param {Ai_Will_Draft_Contextaware_ReInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_will_draft_contextaware_re = /** @type {((inputs?: Ai_Will_Draft_Contextaware_ReInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Will_Draft_Contextaware_ReInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_will_draft_contextaware_re(inputs)
	if (locale === "es") return es_ai_will_draft_contextaware_re(inputs)
	if (locale === "fr") return fr_ai_will_draft_contextaware_re(inputs)
	if (locale === "de") return de_ai_will_draft_contextaware_re(inputs)
	if (locale === "ja") return ja_ai_will_draft_contextaware_re(inputs)
	if (locale === "zh") return zh_ai_will_draft_contextaware_re(inputs)
	if (locale === "ar") return ar_ai_will_draft_contextaware_re(inputs)
	if (locale === "id") return id_ai_will_draft_contextaware_re(inputs)
	if (locale === "it") return it_ai_will_draft_contextaware_re(inputs)
	if (locale === "ru") return ru_ai_will_draft_contextaware_re(inputs)
	if (locale === "pt") return pt_ai_will_draft_contextaware_re(inputs)
	return ko_ai_will_draft_contextaware_re(inputs)
});